module.exports = __webpack_public_path__ + "static/media/bottom_tree_desktop.33fc064e.svg";